"use strict";
/// <reference types="jquery" />
var _init_request = function () {
    /**
     * Init javascript treatment
     */
    //   console.log("init request started");
    toggle_activite();
    $("#id_organisation").on("change", toggle_activite);
};
var get_organisation = function () {
    return $("#id_organisation").val();
};
var toggle_activite = function () {
    /**
     * Hide activite if organisation is not agriculteur
     * Hide unite if organisation is not craw
     */
    if ("agriculteur" === get_organisation()) {
        $("#id_activite").parent().parent().show();
    }
    else {
        $("#id_activite").parent().parent().hide();
        $("#id_activite").val("undefined");
    }
    if ("craw" === get_organisation()) {
        $("#id_unite").parent().parent().show();
    }
    else {
        $("#id_unite").parent().parent().hide();
        $("#id_unite").val("undefined");
    }
};
/**
 * init the javascript
 */
$(window).on("load", function () {
    // Handler when all assets (including images) are loaded
    _init_request();
});
